import { APICore } from './apiCore'

const api = new APICore()

function getOpinometros (params) {
  const baseUrl = '/opinometro'
  return api.get(baseUrl, params)
}

function getOpinometro (id) {
  const baseUrl = `/opinometro/${id}`
  return api.get(baseUrl, {})
}

function addOpinometro (params) {
  const baseUrl = '/opinometro'
  const hasFiles = Array.isArray(params?.files) && params.files.length > 0
  return hasFiles ? api.createWithFile(baseUrl, params) : api.create(baseUrl, params)
}
function duplicateOpinometro (params) {
  const baseUrl = '/opinometro/duplicate'
  return api.create(baseUrl, params)
}
function updateOpinometro (params) {
  const baseUrl = '/opinometro'
  const hasFiles = Array.isArray(params?.files) && params.files.length > 0
  return hasFiles ? api.updateWithFile(baseUrl, params) : api.update(baseUrl, params)
}

function deleteOpinometro (params) {
  const baseUrl = '/opinometro'
  return api.delete(baseUrl, params)
}

export { getOpinometros, getOpinometro, addOpinometro, duplicateOpinometro, updateOpinometro, deleteOpinometro }
